export default __webpack_public_path__ + "static/favicon-adba04bccadae1d2f4a9ad357fa69417.png";